import { Component, Input } from '@angular/core';
import { IStyleOptions } from '@modeso/types__aumico-lib-annualreport-be';
import { I18NextService } from 'angular-i18next';

@Component({
    selector: 'aumico-annual-report-cover-display',
    templateUrl: 'cover.display.component.html',
    styleUrls: ['cover.display.component.scss'],
})
export class AnnualReportCoverDisplayComponent {
    @Input()
    companyName: string;
    @Input()
    companyUID: string;

    @Input()
    companyStreet: string;

    @Input()
    companyAdditionToAddress: string | undefined;

    @Input()
    companyCity: string;

    @Input()
    companyZip: string;

    @Input()
    signaturePlaceDate: string | undefined;

    @Input()
    showAdjustmentInSums: boolean;

    constructor(private i18next: I18NextService) {}
    /**
     * Foremost title
     * eg : Annual financial statement for the financial year 31.03.2021-30.06-2021
     */
    @Input()
    reportTitlePart1: string;
    @Input()
    reportTitlePart2: string;
    @Input()
    reportTitlePart3: string;
    /** Draft label shown above the main title when the report is not sealed. null = hidden. */
    @Input()
    draftLabel: string | null = null;
    /** The report language locale used to translate the draft label in the report language, not the UI language. */
    @Input()
    reportLocale: string;

    textColor: string;
    tableFooterColor: string;
    tableHeaderColor: string;
    titleColor: string;
    @Input() set stylePreferenceOptions(value: IStyleOptions) {
        if (value != null) {
            this.textColor = value.textColor;
            this.tableHeaderColor = value.tableHeaderColor;
            this.tableFooterColor = value.tableFooterColor;
            this.titleColor = value.titleColor;
        }
    }
}
